(ns manage.content-configuration-page.placeholder.db
  (:require [common.content-function.core :as cfn]
            [common.datascript.sequence :as dbseq]
            [common.queries :refer [use-query]]
            [common.resource.query.adset :as adset-queries]
            [common.resource.query.template :as template-queries]
            [common.ui.store :as store]
            [datascript.core :as d]
            [lemonpi.content-function.shared.validation
             :refer [list-missing-required-placeholders]]
            [manage.content-configuration-page.placeholder-expression.db
             :refer [pull-pattern-placeholder-expression
                     value->singular-placeholder-expression]]
            [manage.content-configuration-page.placeholder.type]
            [re-frame.core :as rf]
            [re-posh.core :as rp]
            [uix.core :as uix :refer [defhook]]
            [uix.re-frame :refer [use-subscribe]]))

(def pull-pattern-placeholder
  [:placeholder/name
   :placeholder/type
   :placeholder/visualization-order
   :collection-placeholder/structure
   {:placeholder/default-value pull-pattern-placeholder-expression}])

(defn- ->placeholder [name type]
  {:placeholder/name name
   :placeholder/type type})

(defn tempid [parent-id placeholder-name]
  (str "TMP_ID_placeholder*" parent-id "*" placeholder-name))

(defn ->db-placeholder [owner name type]
  (assoc (->placeholder name type)
         :placeholder/owner-id owner
         :db/id (tempid owner name)))

(def root-container [:content-configuration/id "default"])

(defn db-create-placeholder
  [c name type]
  (dbseq/db-append
   c
   (if (= c root-container)
     :content-configuration/placeholder
     :collection-placeholder/structure)
   :placeholder/visualization-order
   (cond-> (->db-placeholder c name type)

     (and (= c root-container) (not= type :collection))
     (assoc :placeholder/default-value
            (value->singular-placeholder-expression nil ""))

     (= type :collection)
     (assoc :collection-placeholder/structure []
            :placeholder/default-value {:collection-placeholder-expression/item []}))))

(rp/reg-event-ds :placeholder/create
  (fn [_ [_ name type]]
    (db-create-placeholder root-container name type)))

(rp/reg-event-ds :collection-placeholder/add-to-structure
  (fn [db [_ cp name type]]
    (into
     (db-create-placeholder cp name type)
     (for [i (d/q '[:find ?i
                    :in $ ?cp
                    :where
                    (or [?cp :placeholder/default-value ?cpeh]
                        [?cp :placeholder/override ?cpeh])
                    [?cpeh :collection-placeholder-expression/item ?i]]
                  db cp)]
       (assoc (value->singular-placeholder-expression db "")
              :placeholder/_override (tempid cp name)
              :collection-item/_override i)))))

(rf/reg-sub ::template-placeholders
  :<- [:resource.template/all]
  :<- [:resource.adset/template-ids]
  (fn [[templates adset-template-ids] _]
    (map (fn [[k m]]
           (->placeholder (name k) (keyword (:type m))))
         (apply merge (cfn/template-placeholders templates adset-template-ids)))))

(rf/reg-event-fx ::add-from-template
  [(rf/inject-cofx :sub [:ui.store/pull-entity [{:content-configuration/placeholder [:placeholder/name]}] [:content-configuration/id "default"]])]
  (fn [{{existing-placeholders :content-configuration/placeholder} :ui.store/pull-entity} [_ missing-placeholders]]
    (letfn [(create-placeholder [{:placeholder/keys [name type]}]
              (if-let [existing-placeholder (some #(when (= (:placeholder/name %) name) (:db/id %)) existing-placeholders)]
                [{:db/id existing-placeholder :placeholder/type type}] ; ensure existing placeholder's type matches template
                (db-create-placeholder root-container name type)))]
      {:transact (mapcat create-placeholder missing-placeholders)})))

(rp/reg-query-sub :collection-placeholder/find-by-name
  '[:find ?cp .
    :in $ ?n
    :where
    [?cp :placeholder/name ?n]
    [?cp :placeholder/type :collection]])

(rf/reg-sub :collection-placeholder/query-params
  (fn [[_ placeholder _new-placeholder-name]]
    (store/get-value placeholder :placeholder/name))
  (fn [placeholder-name [_ _placeholder new-placeholder-name]]
    {:entity :collection-placeholder :name (or new-placeholder-name placeholder-name)}))

(defhook use-missing-placeholders []
  (let [{:keys [advertiser-id adset-id]} (use-subscribe [:url-context])
        {templates :data} (use-query (template-queries/templates-query {:advertiser-id advertiser-id}))
        {{adset-template-ids :templateRevisionIds} :data} (use-query (adset-queries/adset-query {:adset-id adset-id}))

        template-placeholders (uix/use-memo
                               (fn []
                                 (->> templates
                                      (keep #(when (contains? (set adset-template-ids) (:id (:latestRevision %)))
                                               (:placeholders (:latestRevision %))))
                                      (apply merge)
                                      (map (fn [[k m]]
                                             (->placeholder (name k) (keyword (:type m)))))))
                               [templates adset-template-ids])

        {existing-placeholders :content-configuration/placeholder}
        (use-subscribe [:ui.store/pull-entity
                        [{:content-configuration/placeholder [:placeholder/name :placeholder/type]}]
                        [:content-configuration/id "default"]])

        missing-placeholders (uix/use-memo
                              (fn []
                                (list-missing-required-placeholders existing-placeholders template-placeholders))
                              [existing-placeholders template-placeholders])]
    missing-placeholders))
